import React from "react";
import { Building2, CalendarDays, UserRound, MapPin, Briefcase, Target } from "lucide-react";
import Reveal from "../common/Reveal";

const OVERVIEW_ITEMS = [
  { icon: Building2, label: "회사명", value: "주식회사 엠티에스티 (MTST Co., Ltd.)" },
  { icon: CalendarDays, label: "설립일", value: "2025년 1월 2일" },
  { icon: UserRound, label: "대표자", value: "권정호" },
  {
    icon: MapPin,
    label: "주소",
    value: "경기도 군포시 군포첨단산업2로7번길 8, 지식산업센터동 835호",
  },
  {
    icon: Briefcase,
    label: "사업분야",
    value: "MES 솔루션 개발, 스마트공장 구축, 제조 데이터 분석, OEM·조립 공정 지원, 장비 임대 서비스",
  },
  { icon: Target, label: "비전", value: "스마트 제조 생태계의 글로벌 리더" },
];

const CompanyOverview = () => {
  return (
    <section className="py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="text-center">
          <span className="text-sm font-semibold uppercase tracking-wide text-accent-600">
            Company Overview
          </span>
          <h2 className="mt-3 break-keep text-3xl font-bold text-primary-900 sm:text-4xl">
            회사개요
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-gray-100 bg-gray-100 sm:grid-cols-2">
          {OVERVIEW_ITEMS.map(({ icon: Icon, label, value }, index) => (
            <Reveal key={label} as="div" delay={index * 60} className="flex gap-4 bg-white p-6 transition-colors duration-300 hover:bg-primary-50/40">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-50">
                <Icon className="h-5 w-5 text-primary-700" strokeWidth={1.75} />
              </div>
              <div>
                <div className="text-sm font-semibold text-primary-900">{label}</div>
                <div className="mt-1 break-keep text-sm leading-relaxed text-gray-600">
                  {value}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyOverview;
